import { Toaster } from '@/shared/ui/shadcn/sonner';

import { useTheme } from './useTheme';

export function AppToaster() {
  const { resolvedTheme } = useTheme();
  return <Toaster theme={resolvedTheme} position="top-center" />;
}
